import { MODULE_NAME } from './const';
import { SET_CUSTOM_DOMAINS, ADD_CUSTOM_DOMAIN, UPDATE_CUSTOM_DOMAIN, DELETE_CUSTOM_DOMAIN } from './mutations';
import StoreModuleService from '../StoreModuleService';
import api from '@/api';
import { arrayToObject } from '@/utils/helpers';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const fetchCustomDomains = buildActionObject('fetchCustomDomains');
export const setCustomDomains = buildActionObject('setCustomDomains');
export const addCustomDomain = buildActionObject('addCustomDomain');
export const deleteCustomDomain = buildActionObject('deleteCustomDomain');
export const verifyCustomDomain = buildActionObject('verifyCustomDomain');
export const setDefaultCustomDomain = buildActionObject('setDefaultCustomDomain');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [fetchCustomDomains.action]({ commit }) {
		const domains = await api.listCustomDomains();
		const domainsObj = arrayToObject(domains);
		commit(SET_CUSTOM_DOMAINS, domainsObj);
	},

	async [addCustomDomain.action]({ commit }, { domain }) {
		const resp = await api.addCustomDomain(domain);
		commit(ADD_CUSTOM_DOMAIN, resp);
		return resp;
	},
	async [deleteCustomDomain.action]({ commit }, { domainId }) {
		await api.deleteCustomDomain(domainId);
		commit(DELETE_CUSTOM_DOMAIN, domainId);
	},
	async [verifyCustomDomain.action]({ commit }, { domainId }) {
		const resp = await api.verifyCustomDomain(domainId);
		commit(UPDATE_CUSTOM_DOMAIN, resp);
		return resp;
	},
	async [setDefaultCustomDomain.action]({ dispatch }, { domainId }) {
		const resp = await api.setDefaultCustomDomain(domainId);
		await dispatch(fetchCustomDomains.action); // others might change. get all of them
		return resp;
	},
};

export default actions;
